import Vue from "vue";
import router from "../router";

// router返回
Vue.prototype.back = function() {
    console.log('back', router)
};
// router跳转
Vue.prototype.jump = function(url, data) {
    if (url != null && url.indexOf("/") == -1) {
        router.push({
            name: url,
            params: data,
        });
    } else {
        router.push({
            path: url,
            query: data,
        });
    }
};
// 深拷贝 array & object
Vue.prototype.deepCopy = function(obj) {
    var result = Array.isArray(obj) ? [] : {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (typeof obj[key] === "object" && obj[key] !== null) {
                result[key] = this.deepCopy(obj[key]); //递归复制
            } else {
                result[key] = obj[key];
            }
        }
    }
    return result;
};